module.exports = __webpack_public_path__ + "img/weight.ed75db5c.svg";